<template>
  <v-sheet
    class="pa-2 transparent h-100 w-auto"
    flat
    rounded
    color="transparent"
  >
    <canvas id="chart" ref="chartRef" class="chart-preview-canvas"></canvas>
  </v-sheet>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { Chart, registerables } from "chart.js";
import { applyTransparencyToDatasets } from "@/utils/chartUtils.js";

Chart.register(...registerables);

const props = defineProps({
  type: String,
  data: Array,
  labels: Array,
  horizontal: Boolean,
});

const chartRef = ref(null);
let chartInstance = null;

onMounted(() => {
  renderChart();
});

watch(
  () => props.type,
  () => {
    if (chartInstance) {
      chartInstance.destroy();
    }
    renderChart();
  },
);

function renderChart() {
  // Apply transparency to dataset colors
  const dataWithTransparency = {
    labels: props.labels,
    datasets: applyTransparencyToDatasets(props.data)
  };

  chartInstance = new Chart(chartRef.value, {
    type: props.type === "area" ? "line" : props.type,
    data: dataWithTransparency,
    options: {
      responsive: true,
      maintainAspectRatio: false,
      indexAxis: props.horizontal ? 'y' : 'x',
      plugins: {
        legend: {
          display: false,
        },
        title: {
          display: false,
        },
      },
      scales: props.type === "doughnut" || props.type === "polarArea" || props.type === "radar" ? undefined : {
        x: {
          display: false,
        },
        y: {
          display: false,
        },
      },
      interaction: {
        mode: "none",
      },
    },
  });
}
</script>
